import { API_BASE_URL } from '../config';

// Cache for the authalt token
let cachedToken = null;
let tokenExpiry = null;

/**
 * Fetch a fresh JWT token from the backend for authalt API authentication.
 * The backend generates this token using the RSA private key.
 * @param {boolean} forceRefresh - If true, bypass cache and fetch new token
 */
export const getAuthaltToken = async (forceRefresh = false) => {
  // Return cached token if still valid (with 1 hour buffer)
  if (!forceRefresh && cachedToken && tokenExpiry && Date.now() < tokenExpiry - 3600000) {
    return cachedToken;
  }

  try {
    const response = await fetch(`${API_BASE_URL}/api/authalt/token`, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json'
      },
      credentials: 'include' // Include cookies for authentication
    });

    if (!response.ok) {
      throw new Error(`Failed to fetch authalt token: ${response.status}`);
    }

    const data = await response.json();
    
    if (!data.token) {
      throw new Error('No token received from backend');
    }

    // Cache the token (expires in ~30 days, we cache for 24 hours)
    cachedToken = data.token;
    tokenExpiry = Date.now() + (24 * 60 * 60 * 1000); // 24 hours

    return cachedToken;
  } catch (error) {
    console.error('Error fetching authalt token:', error);
    // Fallback to empty string - calls will fail but app won't crash
    return '';
  }
};

/**
 * Clear the cached token (useful for logout or when token is known to be invalid)
 */
export const clearAuthaltToken = () => {
  cachedToken = null;
  tokenExpiry = null;
};

// Authalt API base URL
export const AUTHALT_API_BASE = 'https://authalt.bsynapse.com/atmantanschedule';
